<template>
  <div class="main-activity-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="140px" size="small">
      <!-- 基础信息 -->
      <div class="white-container">
        <div class="section-title">基础信息</div>
        <el-form-item label="赛事类型" prop="combineMode" style="width: 500px">
          <el-radio-group v-model="form.combineMode">
            <el-radio :label="1">计时赛</el-radio>
            <el-radio :label="0">常规赛</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="总计可报名" prop="totalRegistrableCount">
          <el-input v-model.number="form.totalRegistrableCount" placeholder="请输入总计可报名" style="width: 200px" />
          <span class="input-unit">次</span>
        </el-form-item>
        <el-form-item label="每日可报名" prop="dailyRegistrableCount">
          <el-input v-model.number="form.dailyRegistrableCount" placeholder="请输入每日可报名" style="width: 200px" />
          <span class="input-unit">次</span>
        </el-form-item>
        <el-form-item label="活动标题" prop="title" style="width: 500px">
          <el-input v-model="form.title" placeholder="请输入活动标题" maxlength="23" show-word-limit />
        </el-form-item>
        <el-form-item label="活动城市" prop="uaEventCityId" style="width: 500px">
          <el-select v-model="form.uaEventCityId" placeholder="请选择" filterable>
            <el-option v-for="city in cityList" :key="city.id" :label="city.name" :value="city.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="活动日期" prop="time" style="width: 500px">
          <el-date-picker
            v-model="form.time"
            type="datetimerange"
            range-separator="-"
            start-placeholder="活动开始日期"
            end-placeholder="活动结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <div class="flex address-row">
          <el-form-item label="活动地址" prop="address" style="width: 500px">
            <el-input v-model="form.address" placeholder="请输入活动地址" maxlength="200" show-word-limit />
          </el-form-item>
          <el-button type="primary" @click="openMap">打开地图</el-button>
          <el-form-item label="坐标" class="coordinate-item">
            <el-input v-model="form.coordinate" placeholder="请输入纬度,经度" />
          </el-form-item>
        </div>
        <el-form-item label="活动介绍" prop="introduction" style="width: 800px">
          <el-input v-model="form.introduction" type="textarea" :rows="4" placeholder="请输入活动介绍" maxlength="1000" show-word-limit />
        </el-form-item>
        <el-form-item label="个人赛场次">
          <el-select v-model="form.personalSubActivityIds" multiple filterable remote reserve-keyword value-key="id" :remote-method="(query) => searchSubActivity(query, 1)" placeholder="输入活动名称搜索" style="width: 600px" prefix-icon="el-icon-search">
            <el-option v-for="item in personalSubActivityOptions" :key="item.id" :label="item.name + ' ID:' + item.id" :value="item" />
          </el-select>
          <div v-if="form.personalSubActivityIds.length" class="selected-tabs">
            <div v-for="item in form.personalSubActivityIds" :key="item.id" class="selected-tab">
              <i class="el-icon-close" @click="removeSelected('personalSubActivityIds', item.id)" />
              <span>{{ item.name }} ID: {{ item.id }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="团体赛场次">
          <el-select v-model="form.teamSubActivityIds" multiple filterable remote reserve-keyword value-key="id" :remote-method="(query) => searchSubActivity(query, 0)" placeholder="输入活动名称搜索" style="width: 600px" prefix-icon="el-icon-search">
            <el-option v-for="item in teamSubActivityOptions" :key="item.id" :label="item.name + ' ID:' + item.id" :value="item" />
          </el-select>
          <div v-if="form.teamSubActivityIds.length" class="selected-tabs">
            <div v-for="item in form.teamSubActivityIds" :key="item.id" class="selected-tab">
              <i class="el-icon-close" @click="removeSelected('teamSubActivityIds', item.id)" />
              <span>{{ item.name }} ID: {{ item.id }}</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="竞赛规则链接" prop="competitionRuleLink" style="width: 500px">
          <el-input v-model="form.competitionRuleLink" placeholder="请输入竞赛规则链接" maxlength="500" />
        </el-form-item>
      </div>

      <!-- 高光时刻 -->
      <div class="white-container marginTop">
        <div class="section-title"><span style="color:#F56C6C;margin-right:4px;">*</span>高光时刻</div>
        <div class="flex" style="align-items: center;">
          <el-form-item prop="rankingBanner" label-width="0">
            <UploadImage :url="form.rankingBanner" save-path="nextCombine/mainActivity/" title="" size-tips="1005px*503px" :show-replace="false" class-name="custom-size" @upload="(url) => form.rankingBanner = url" />
          </el-form-item>
          <div style="margin-left: 20px;" class="highlight-links">
            <el-radio-group v-model="form.highlightType">
              <div class="flex" style="margin-bottom: 24px; align-items: center;">
                <el-radio :label="1" style="width: 120px; text-align: right;">云相册链接</el-radio>
                <el-input v-model="form.rankingBannerLink" :disabled="form.highlightType !== 1" placeholder="请输入云相册链接BANNER" maxlength="500" style="width: 380px;" />
              </div>
              <div class="flex" style="align-items: center;">
                <el-radio :label="2" style="width: 120px; text-align: right;">UAHOUSE链接</el-radio>
                <el-input v-model="form.rankingEndLink" :disabled="form.highlightType !== 2" placeholder="请输入UA HOUSE链接" maxlength="500" style="width: 380px;" />
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>

      <!-- EC BANNER 配置 -->
      <div class="white-container marginTop">
        <div class="section-title">EC BANNER</div>
        <div class="flex ec-banner-row">
          <el-form-item prop="ecBannerImg" label-width="0">
            <UploadImage :url="form.ecBannerImg" save-path="nextCombine/mainActivity/" title="" size-tips="1005px*503px" :limit-size="5" :show-replace="false" class-name="custom-size" @upload="onUploadImage('ecBannerImg', $event)" />
          </el-form-item>
          <el-form-item label="EC BANNER链接" class="ec-banner-link-item">
            <el-input v-model="form.ecBannerLink" placeholder="请输入EC BANNER链接" maxlength="500" style="width: 380px;" />
          </el-form-item>
        </div>
      </div>

      <!-- 上传视频 -->
      <div class="white-container marginTop">
        <div class="section-title">上传视频</div>
        <div class="video-gray-box">
          <div v-for="(item, index) in form.mediaLinkList" :key="index" v-loading="uploadingVideoIndex === index" class="video-item-row flex" style="margin-bottom: 20px; justify-content: space-between; align-items: flex-end;">
            <div v-if="item.mediaUrl">
              <video :src="item.mediaUrl" class="custom-video" preload="auto" controls playsinline webkit-playsinline style="width: 300px;" />
              <div style="margin-top: 10px;">
                <el-upload action="" accept="video/*" :show-file-list="false" :on-change="(file) => upLoadVideo(file, index)" :auto-upload="false">
                  <el-button size="small" type="primary" :disabled="uploadingVideoIndex !== -1">重新上传</el-button>
                </el-upload>
                <div style="font-size: 12px; color: #909399; margin-top: 4px;">支持上传*MP4、*MOV格式视频，大小不超过100MB，尺寸:16:9或4:3</div>
              </div>
            </div>
            <div v-else>
              <el-upload action="" accept="video/*" :show-file-list="false" :on-change="(file) => upLoadVideo(file, index)" :auto-upload="false">
                <el-button size="small" type="primary" :disabled="uploadingVideoIndex !== -1">添加视频</el-button>
              </el-upload>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">支持上传*MP4、*MOV格式视频，大小不超过100MB，尺寸:16:9或4:3</div>
            </div>
            <el-button type="text" style="color: #F56C6C;" :disabled="uploadingVideoIndex !== -1" @click="removeVideo(index)">删除</el-button>
          </div>
        </div>
        <div style="text-align: center; margin-top: 20px;">
          <el-button @click="addVideoItem"><i class="el-icon-plus" /> 添加视频</el-button>
        </div>
      </div>

      <!-- 上传图片 -->
      <div class="white-container marginTop">
        <div class="section-title">上传图片</div>
        <div class="upload-images-row">
          <el-form-item prop="activityListImg" label-width="0">
            <UploadImage :url="form.activityListImg" save-path="nextCombine/mainActivity/" title="活动列表图" size-tips="360px*576px" :limit-size="5" :show-replace="false" @upload="onUploadImage('activityListImg', $event)" />
          </el-form-item>
          <el-form-item prop="headImg" label-width="0">
            <UploadImage :url="form.headImg" save-path="nextCombine/mainActivity/" title="活动主图" size-tips="1125px*1125px" :limit-size="5" :show-replace="false" @upload="onUploadImage('headImg', $event)" />
          </el-form-item>
          <el-form-item prop="shareImg" label-width="0">
            <UploadImage :url="form.shareImg" save-path="nextCombine/mainActivity/" title="活动分享海报" size-tips="849px*849px" :limit-size="5" :show-replace="false" @upload="onUploadImage('shareImg', $event)" />
          </el-form-item>
          <el-form-item prop="shareCardImg" label-width="0">
            <UploadImage :url="form.shareCardImg" save-path="nextCombine/mainActivity/" title="活动分享卡片" size-tips="500px*400px" :limit-size="5" :show-replace="false" @upload="onUploadImage('shareCardImg', $event)" />
          </el-form-item>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="white-container marginTop">
        <el-form-item>
          <div class="flex btns">
            <el-button type="info" @click="cancelBtn">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage';
import { getFileType } from '@/common/js/util';

import Dialog from '@/components/Dialog';
import { getMainActivityDetail, addMainActivity, editMainActivity, cityList as fetchCityList, selectableSubActivities } from '@/api/combine';

export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      formDialogShow: false,
      information: {},
      cancelTxt: '',
      isEdit: false,
      cityList: [],
      personalSubActivityOptions: [],
      teamSubActivityOptions: [],
      uploadingVideoIndex: -1,
      form: {
        id: undefined,
        totalRegistrableCount: undefined,
        dailyRegistrableCount: undefined,
        title: '',
        uaEventCityId: undefined,
        combineMode: 0,
        time: [],
        address: '',
        coordinate: '',
        introduction: '',
        activityListImg: '',
        headImg: '',
        shareImg: '',
        shareCardImg: '',
        rankingBanner: '',
        rankingBannerLink: '',
        rankingEndLink: '',
        ecBannerImg: '',
        ecBannerLink: '',
        highlightType: 1,
        mediaLinkList: [],
        competitionRuleLink: '',
        personalSubActivityIds: [],
        teamSubActivityIds: [],
      },
      rules: {
        totalRegistrableCount: [
          { required: true, message: '请输入总计可报名', trigger: 'blur' },
        ],
        dailyRegistrableCount: [
          { required: true, message: '请输入每日可报名', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
        ],
        uaEventCityId: [
          { required: true, message: '请选择城市', trigger: 'change' },
        ],
        combineMode: [
          { required: true, message: '请选择赛事类型', trigger: 'change' },
        ],
        time: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
        ],
        address: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        coordinate: [
          { required: true, message: '请输入活动地址的经纬度', trigger: 'blur' },
        ],
        introduction: [
          { required: true, message: '请输入活动介绍', trigger: 'blur' },
        ],
        competitionRuleLink: [
          { required: true, message: '请输入竞赛规则链接', trigger: 'blur' },
        ],
        rankingBanner: [
          { required: true, message: '请上传高光时刻图片', trigger: 'change' },
        ],
        activityListImg: [
          { required: true, message: '请上传活动列表图', trigger: 'change' },
        ],
        headImg: [
          { required: true, message: '请上传活动主图', trigger: 'change' },
        ],
        shareImg: [
          { required: true, message: '请上传活动分享海报', trigger: 'change' },
        ],
        shareCardImg: [
          { required: true, message: '请上传活动分享卡片', trigger: 'change' },
        ],
      },
    };
  },
  mounted() {
    const { query } = this.$route;
    if (query.id) {
      this.isEdit = true;
      this.cancelTxt = '编辑';
      this.getDetail(query.id);
    } else if (query.copyid) {
      this.cancelTxt = '复制';
      this.getDetail(query.copyid, true);
    } else {
      this.cancelTxt = '新增';
    }
    this.fetchCityList();
  },
  methods: {
    getOptionName(options, id, showId) {
      const item = options.find(o => o.id === id);
      console.log(options, "+++++");
      return showId ? `${id} ${item?.name || ''}` : (item?.name || '');
    },
    removeSelected(field, id) {
      this.$set(this.form, field, this.form[field].filter(v => v.id !== id));
    },
    onUploadImage(field, url) {
      this.form[field] = url;
      this.$nextTick(() => {
        this.$refs.form.validateField(field);
      });
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formDialogShow = true;
          this.information = {
            operation: 'submit',
            icon: 'warn',
            subTitle: '确认保存活动信息？',
          };
        }
      });
    },
    getDetail(id, isCopy = false) {
      getMainActivityDetail(id).then(res => {
        let hType = 1;
        if (res.rankingEndLink) {
          hType = 2;
        }
        if (isCopy) {
          res.personalSubActivities = [];
          res.teamSubActivities = [];
        }
        this.form = Object.assign(this.form, res, {
          id: isCopy ? undefined : res.id,
          time: res.beginTime && res.endTime ? [res.beginTime, res.endTime] : [],
          personalSubActivityIds: res.personalSubActivities || [],
          teamSubActivityIds: res.teamSubActivities || [],
          highlightType: hType,
        });
        this.personalSubActivityOptions = (res.personalSubActivities || []).concat(this.personalSubActivityOptions);
        this.teamSubActivityOptions = (res.teamSubActivities || []).concat(this.teamSubActivityOptions);
      });
    },
    upLoadVideo(file, index) {
      if (getFileType(file.name) !== 'video') {
        this.$message.error('仅支持上传*.mov、*.mp4格式');
        return;
      }
      this.uploadingVideoIndex = index;
      this.$Api.uploadFile.putCloudDemandUpload({
        mediaFile: file.raw,
        onUploadProgress: progressEvent => {
          const process = parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
          this.uploadProgress = process;
        },
      }).then(res => {
        const obj = {};
        obj[res.fileId] = res.mediaUrl;
        this.$set(this.form.mediaLinkList[index], 'fileId', res.fileId);
        this.$set(this.form.mediaLinkList[index], 'mediaUrl', res.mediaUrl);
        console.log('**-**', this.form.mediaLinkList[0]);
      }).catch((err) => {
        console.log("err++*--", err);
        this.$message.error('上传失败！');
      }).finally(() => {
        this.uploadingVideoIndex = -1;
      });
    },
    removeVideo(index) {
      this.form.mediaLinkList.splice(index, 1);
    },
    addVideoItem() {
      this.form.mediaLinkList.push({ fileId: '', mediaUrl: '' });
    },
    searchSubActivity(keyword, type) {
      const options = type === 1 ? 'personalSubActivityOptions' : 'teamSubActivityOptions';
      const activityMode = this.form.combineMode === 1 ? (type === 1 ? 2 : 1) : 0;
      selectableSubActivities({
        type,
        keyword,
        combineMode: this.form.combineMode,
        activityMode,
      }).then(res => {
        this[options] = res || [];
      });
    },
    fetchCityList() {
      fetchCityList().then(res => {
        this.cityList = res || [];
      });
    },
    async addEditItem() {
      const params = {
        ...this.form,
        beginTime: this.form.time[0],
        endTime: this.form.time[1],
        mediaLinkList: this.form?.mediaLinkList?.length ? this.form.mediaLinkList.filter(item => item.fileId) : [],
        mediaList: this.form?.mediaLinkList?.length ? this.form.mediaLinkList.filter(item => item.fileId).map(item => item.fileId) : [],
      };
      delete params.time;
      params.rankingEndLink = params.rankingEndLink || '';
      params.rankingBannerLink = params.rankingBannerLink || '';
      delete params.highlightType;
      params.personalSubActivityIds = (params.personalSubActivityIds || []).map(item => item.id);
      params.teamSubActivityIds = (params.teamSubActivityIds || []).map(item => item.id);
      delete params.personalSubActivities;
      delete params.teamSubActivities;
      params.latitude = this.form.coordinate?.split(',')[0];
      params.longitude = this.form.coordinate?.split(',')[1];
      const api = params.id ? editMainActivity : addMainActivity;
      await api(params);
      this.$message.success(params.id ? '编辑成功' : '保存成功');
      this.$router.go(-1);
    },
    cancelBtn() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelTxt}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation === 'cancel') {
        this.$router.go(-1);
      } else if (this.information.operation === 'submit') {
        this.addEditItem();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main-activity-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 24px;
  }
  .btns {
    align-items: center;
    justify-content: center;
  }
  .selected-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }
  .selected-tab {
    display: flex;
    align-items: center;
    height: 29px;
    padding: 4px 10px;
    background: #f0f2f5;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
    .el-icon-close {
      padding: 2px;
      margin-right: 6px;
      font-size: 10px;
      cursor: pointer;
      color: #fff;
      border-radius: 50%;
      background-color: #6D6D6D;
      &:hover {
        color: #F56C6C;
      }
    }
  }
  .marginTop {
    margin-top: 20px;
  }
  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
  }
  .input-unit {
    margin-left: 8px;
    color: #606266;
  }
  .address-row {
    align-items: center;
    margin-bottom: 24px;
    .el-button {
      margin-left: 10px;
      flex-shrink: 0;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .coordinate-item {
    margin-left: 10px;
    ::v-deep .el-form-item__label {
      width: 60px !important;
    }
    ::v-deep .el-form-item__content {
      margin-left: 60px !important;
    }
  }
  .upload-images-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    ::v-deep .uploader .tip {
      margin-top: 10px;
      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 2px;
      }
    }
  }
  .custom-size {
    ::v-deep .el-upload {
      width: 300px;
      height: 150px;
    }
    ::v-deep .el-icon-plus {
      width: 300px;
      height: 150px;
      line-height: 150px;
    }
  }
  .ec-banner-row {
    align-items: center;
    .ec-banner-link-item {
      margin-left: 20px;
    }
  }
  .video-gray-box {
    background-color: #f7f8f9;
    padding: 24px;
    border-radius: 4px;
    margin-bottom: 24px;
    .add-video-btn {
      width: 200px;
      margin: 0 auto;
      display: block;
      border-style: dashed;
    }
    .custom-video {
      border-radius: 4px;
    }
  }
}
</style>
